import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { PlacementProps } from '../..';
import { OfferingType, ProductLicenseResource } from '../../../../../Types';
import OfferingTypeList from './OfferingTypeList';
import Title from './Title';
import Congrats from '../Recommendations/Congrats';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import Recommendations from '../Recommendations';

const buildOmittedOfferingTypesArray = (
  productLicenseOfferingTypes: ReadonlyArray<OfferingType>,
  learningDesignOfferingTypes: ReadonlyArray<OfferingType>,
) => productLicenseOfferingTypes.filter((at) => !learningDesignOfferingTypes.includes(at));

interface Props {
  active: boolean;
  productLicense: ProductLicenseResource;
  productLicenseOfferingTypes: ReadonlyArray<OfferingType>;
  learningDesignOfferingTypes: ReadonlyArray<OfferingType>;
  placementProps?: PlacementProps;
}

function UsageOverview({
  active,
  productLicense,
  productLicenseOfferingTypes,
  learningDesignOfferingTypes,
  placementProps,
}: Props) {
  return (
    <div
      id="ProductChecker"
      className={clsx(
        active ? 'block' : 'hidden',
        placementProps?.position?.top ? placementProps.position.top : '',
        placementProps?.position?.right ? placementProps.position.right : '',
        'z-[1000]',
        'absolute flex-col w-[355px] p-4 bg-white border-1 border-gray-200 rounded text-sm',
      )}
    >
      <h3 className="mb-4">
        <Title productLicense={productLicense} />
      </h3>
      <OfferingTypeList
        learningDesignOfferingTypes={learningDesignOfferingTypes}
        productLicenseOfferingTypes={productLicenseOfferingTypes}
      />
      {when(productLicenseOfferingTypes.length > learningDesignOfferingTypes.length, {})
        .andThen(() =>
          fromArrayMaybe(
            buildOmittedOfferingTypesArray(
              productLicenseOfferingTypes,
              learningDesignOfferingTypes,
            ),
          ),
        )
        .map((omissions) => <Recommendations omissions={omissions} />)
        .getOrElse(emptyFragment)}
      {when(productLicenseOfferingTypes.length === learningDesignOfferingTypes.length, {})
        .map(() => <Congrats productLicense={productLicense} />)
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(UsageOverview);
